import { useEffect, useState, useCallback } from "react";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchPracticeSentences } from "./practiceSentenceService";
import "./PracticeSentencePage.css";

const PracticeSentencePage = () => {
 const [sentences, setSentences] = useState([]);
 const [loading, setLoading] = useState(false);
 const [page, setPage] = useState(0);
 const [totalPages, setTotalPages] = useState(0);
 const [totalItems, setTotalItems] = useState(0);
 const [search, setSearch] = useState("");

 const loadSentences = useCallback(async () => {
 setLoading(true);
 const res = await fetchPracticeSentences({ page, size: 20, search });
 if (res.status === 200 && res.data?.status) {
 setSentences(res.data.data || []);
 setTotalPages(res.data.totalPages || 0);
 setTotalItems(res.data.totalItems || 0);
 } else {
 setSentences([]);
 setTotalPages(0);
 setTotalItems(0);
 }
 setLoading(false);
 }, [page, search]);

 useEffect(() => {
 loadSentences();
 }, [loadSentences]);

 return (
 <>
 <Navbar />
 <div className="ps-page">
 <h1 className="ps-title">✍️ Practice Sentences</h1>
 <p className="ps-subtitle">
 Read and speak these sentences aloud to build fluency and confidence.
 </p>

 <div className="ps-search-bar">
 <input
 type="text"
 className="ps-search-input"
 placeholder="Search sentences..."
 value={search}
 onChange={(e) => {
 setPage(0);
 setSearch(e.target.value);
 }}
 />
 </div>

 {totalItems > 0 && (
 <p className="ps-count">{totalItems} sentences available</p>
 )}

 {loading ? (
 <p className="ps-loading">Loading...</p>
 ) : sentences.length === 0 ? (
 <p className="ps-empty">No sentences found.</p>
 ) : (
 <div className="ps-list">
 {sentences.map((sentence, index) => (
 <div key={index} className="ps-card">
 <span className="ps-index">{page * 20 + index + 1}</span>
 <p className="ps-text">{sentence}</p>
 </div>
 ))}
 </div>
 )}

 {totalPages > 1 && (
 <div className="ps-pagination">
 <button disabled={page === 0} onClick={() => setPage(page - 1)}>
 ← Prev
 </button>
 <span>
 Page {page + 1} / {totalPages}
 </span>
 <button
 disabled={page + 1 >= totalPages}
 onClick={() => setPage(page + 1)}
 >
 Next →
 </button>
 </div>
 )}
 </div>
 <Footer />
 </>
 );
};

export default PracticeSentencePage;
